/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guidevideo_Add1Inputs */

const vi_guidevideo_add1 = /** @type {(inputs: Guidevideo_Add1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm video`)
};

/**

* @param {Guidevideo_Add1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const guidevideo_add1 = /** @type {((inputs?: Guidevideo_Add1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guidevideo_Add1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_guidevideo_add1(inputs)
});
export { guidevideo_add1 as "guideVideo_add" }